import React from 'react';
import PropTypes from 'prop-types';
import { Tree, Spin } from 'antd';
import Search from 'components/Search';
import Icon from 'components/Icon';

function noop() {}

export default class ListSelectTreeSource extends React.Component {
  static defaultProps = {
    dataSource: [],
    titleText: '',
    treeKey: 'key',
    treeTitleKey: 'title',
    showSearch: false,
    handleClear: noop,
    handleFilter: noop,
    handleSelect: noop,
    handleSelectAll: noop
  };

  static propTypes = {
    prefixCls: PropTypes.string,
    treeData: PropTypes.array,
    checkedKeys: PropTypes.array,
    showSearch: PropTypes.bool,
    searchPlaceholder: PropTypes.string,
    titleText: PropTypes.string,
    treeKey: PropTypes.string,
    treeTitleKey: PropTypes.string,
    style: PropTypes.object,
    handleClear: PropTypes.func,
    notFoundContent: PropTypes.string,
    filter: PropTypes.string,
    handleFilter: PropTypes.func,
    treeRender: PropTypes.func,
    loading: PropTypes.bool,
    flatTreeData: PropTypes.array
  };

  state = {
    searchList: []
  };

  handleFilter = value => {
    this.renderFilterResult(value);
    this.props.handleFilter(value);
  };

  handleClear = () => {
    this.renderFilterResult('');
    this.props.handleFilter('');
  };

  renderTreeNodes = data => {
    const { treeKey, treeTitleKey } = this.props;

    return data.map(item => {
      const treeProps = {
        ...item,
        key: item[treeKey],
        title: item[treeTitleKey],
        dataRef: item
      };

      if (item.children) {
        return (
          <Tree.TreeNode {...treeProps} icon={<Icon className="material-folder-o" />}>
            {this.renderTreeNodes(item.children)}
          </Tree.TreeNode>
        );
      }
      return <Tree.TreeNode {...treeProps} />;
    });
  };

  renderFilterResult = filter => {
    const { flatTreeData, treeTitleKey, asyncSearch } = this.props;
    if (asyncSearch) {
      const promise = asyncSearch(filter);
      if (promise.then) {
        promise.then(listItem => {
          this.setState({
            searchList: listItem
          });
        });
      }
    } else {
      this.setState({
        searchList: flatTreeData.filter(
          item => item[treeTitleKey].indexOf(filter) >= 0
        )
      });
    }
  };

  renderSearchItem = searchList =>
    searchList.map((item, index) => (
      <li
        className="list-comp-item"
        title={item[this.props.treeTitleKey]}
        key={item[this.props.treeKey]}
        onClick={() => this.handleSelect(item)}
      >
        <span className="list-comp-item-body">
          {item[this.props.treeTitleKey]}
        </span>
      </li>
    ));

  handleSelect = selectedItem => {
    const { checkedKeys, checkedNodes, treeKey } = this.props;
     
    let _checkedNodes = checkedNodes ? [...checkedNodes] : [];

    if (
      checkedKeys &&
      checkedKeys.some(key => key === selectedItem[treeKey])
    ) {
      _checkedNodes = _checkedNodes.filter(
        item => item[treeKey] !== selectedItem[treeKey]
      );
    } else {
      _checkedNodes.push(selectedItem);
    }
    this.props.onChecked(_checkedNodes);
  };

  onCheck = (_checkedKeys, info) => {
    this.props.onChecked(info.checked, info.checkedNodes, info.node);
  }

  onSelect = (_selectedKeys, info) => {
    
  };

  render() {
    const {
      prefixCls,
      loading,
      treeData,
      titleText,
      loadData,
      filter,
      showSearch,
      style,
      checkedKeys
    } = this.props;

    const { searchList } = this.state;

    let { searchPlaceholder, notFoundContent } = this.props;

    const showTree = (
      <Tree
        checkable
        showLine
        checkStrictly={true}//checkable状态下节点选择完全受控（父子节点选中状态不再关联）
        defaultExpandedKeys={["-1"]}
        onCheck={this.onCheck}
        checkedKeys={checkedKeys || []}
        onSelect={this.onSelect}
        loadData={loadData}
      >
        {this.renderTreeNodes(treeData)}
      </Tree>
    );

    return (
      <div className={prefixCls} style={style}>
        <div className={`${prefixCls}-header tree-title`}>{titleText}</div>
        <div
          className={
            showSearch
              ? `${prefixCls}-body ${prefixCls}-body-with-search`
              : `${prefixCls}-body`
          }
        >
          {showSearch ? (
            <div className={`${prefixCls}-body-search-wrapper`}>
              <Search
                prefixCls={`${prefixCls}-search`}
                onChange={this.handleFilter}
                handleClear={this.handleClear}
                placeholder={searchPlaceholder || '请输入搜索内容'}
              />
            </div>
          ) : null}
          <div className={`${prefixCls}-body-content tree-content`}>
            {filter ? (
              <ul className="tree-filter-result">
                {this.renderSearchItem(searchList)}
              </ul>
            ) : null}
            {treeData.length ? (
              showTree
            ) : (
              <div className={`${prefixCls}-body-content-not-found`}>
                {loading ? (
                  <Spin spinning={loading} />
                ) : (
                  notFoundContent || '列表为空'
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TransferSelectTree/ListSelectTreeSource.js